import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';
import { barFill } from '../theme/tokens';

interface FillBarProps {
  color: string;
  percent: number | null;
  label: string;
  valueText?: string;
  height?: number;
  sx?: SxProps<Theme>;
}

export function FillBar({
  color,
  percent,
  label,
  valueText,
  height = 6,
  sx,
}: FillBarProps): ReactNode {
  const clamped = percent === null ? 0 : Math.min(Math.max(percent, 0), 100);
  return (
    <Box
      role="progressbar"
      aria-label={label}
      aria-valuenow={clamped}
      aria-valuetext={valueText}
      aria-valuemin={0}
      aria-valuemax={100}
      sx={[
        (theme) => ({
          height,
          borderRadius: `${theme.radius.pill}px`,
          bgcolor: 'divider',
          overflow: 'hidden',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box
        sx={(theme) => ({
          width: `${clamped}%`,
          height: '100%',
          borderRadius: `${theme.radius.pill}px`,
          background: barFill(color),
        })}
      />
    </Box>
  );
}
